import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mensual',
    standalone: false
})
@Injectable({
  providedIn: 'root'
})
export class MensualPipe implements PipeTransform {
  transform(value: number, numberOfMonths: number): number {
    numberOfMonths = numberOfMonths - 2;
    const newNumberOfMonths = numberOfMonths + 1;

    const interestAmount = this.calculateInterestAmount(value);
    const R = 0.0104125;
    const R_PLUS = 1.0104125;
    return ((interestAmount * Math.pow(R_PLUS, numberOfMonths)) * R) / (Math.pow(R_PLUS, newNumberOfMonths) - 1);
  }
  calculateInterestAmount(totalSellingPrice: number): number {
    const R = 0.0104125;
    return totalSellingPrice + (totalSellingPrice * R * 2);
  }
}
